import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: false,
  selector: '[appNoSymbols]'
})
export class NoSymbolsDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('blur') onBlur() {
    const value = this.ngControl.control.value;
    if (value) {
      this.ngControl.control.patchValue(value.replace(/[^a-zA-Z0-9 ]/g, '').trim());
    }
  }
}
